import { Box, Button, Card, CardContent, CircularProgress, Grid, IconButton, InputLabel, List, ListItem, ListItemButton, ListItemText, MenuItem, Modal, Select, Tab, Tabs, TextField, Toolbar, Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete'
import { removeFromIndexedDB } from "../../../utils";
import ImagesSlider from "../../images/ImageSlider";
import { useEffect, useState } from "react";
import { msg } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import SaveIcon from '@mui/icons-material/Save'
import ThirdPage from "../../reportFormPages/ThirdPage";
import { ActionsToolBar } from "../../grid/ActionsToolbar";
import AddIcon from '@mui/icons-material/Add';
import { AgGridReact } from "ag-grid-react";
import { ClientSideRowModelModule, NumberEditorModule, ValidationModule } from "ag-grid-community";
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import ModalPreviewImage from "./ModalPreviewImage";
import httpReq from "../../../ce-services/http-req";
import {Remove} from "@mui/icons-material";
import SvgCustomIcon from "../../icons/SvgCustomIcon";


const ModalManageDraft = ({
    isOpen,
    rowsData,
    isOnline,
    setIsOpen,
    rowToManage,
    isMobile,
    getRowsByIndexedDb,
    setIsViewAlert,
    setAlertMessage,
    regionNameFounded,
    vehicleTypes
}) => {
    const { control, setValue, getValues, handleSubmit, watch, handlePicture, register, getFieldState, reset } = useForm(
        {
            mode: 'onChange',
            defaultValues: {
                firstName: rowToManage.publicAccident.firstName,
                lastName: rowToManage.publicAccident.lastName,
                data: rowToManage.publicAccident.data,
                email: rowToManage.publicAccident.email,
                latitude: rowToManage.publicAccident.latitude,
                longitude: rowToManage.publicAccident.longitude,
                phoneNumber: rowToManage.publicAccident.phoneNumber,
                region: regionNameFounded(rowToManage.publicAccident.regionFk)
            }
        }
    )
    const tabs = [
        {
            id: 1,
            label: 'General Info'
        },
        {
            id: 2,
            label: 'Involved vehicles'
        },
        {
            id: 3,
            label: 'Photos'
        }
    ]
    const [selectedTab, setSelectedTab] = useState({
        id: 1,
        label: 'General Info'
    })
    const [selectedSingleVehicle, setSelectedSingleVehicle] = useState(null)
    const [images, setImages] = useState(rowToManage.publicAccidentImages)
    const [photoPreview, setPhotoPreview] = useState(null)
    const { _ } = useLingui()
    const gridItemStyle = { display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: !isMobile ? 'center' : 'space-between' }
    const [isLoading, setIsLoading] = useState(false)
    const [publicAccidentId, setPublicAccidentId] = useState(null)
    const SelectEditor = (props) => {
        const [value, setValue] = useState(props.node.data.admount)
        return (
            <Select
                size="small"
                value={value}
                onChange={(e) => {
                    props.node.setDataValue(props.colDef.field, e.target.value);
                    setValue(e.target.value)
                }}
                autoFocus
                fullWidth
            >
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(((n, k) => {
                    return (
                        <MenuItem value={n}>{n}</MenuItem>
                    )
                }))}
            </Select>
        )
    }
    const ToolbarTable = (props) => {
        let selectedRow = props.node.data;

        const deleteAction = () => {
            const r = [...vehiclesRowsData]
            const idx = r.findIndex(a => {
                return a.id === selectedRow.id
            })
            if (idx >= 0) {
                r.splice(idx, 1)
                setVehiclesRowsData(r)
            }
        };

        return <ActionsToolBar hasDelete deleteAction={deleteAction} />;
    };
    const [vehiclesRowsData, setVehiclesRowsData] = useState(rowToManage.publicAccidentVehicleTypes)
    const colsLabel = [
        {
            field: 'name',
            headerName: 'Name',
            flex: 3
        },
        {
            field: 'admount',
            headerName: 'Quantity',
            flex: 3,
            cellRenderer: SelectEditor
        },
        { headerName: 'Actions', cellRenderer: ToolbarTable, flex: !isMobile ? 1 : 2 }
    ]



    const GeneralInfo = () => {
        return (
            <Grid container sx={{ marginTop: 2, display: 'flex' }} spacing={2}>
                <Grid item
                    lg={6}
                    xs={12}
                    sx={{}}>
                    <Controller
                        name='firstName'
                        control={control}
                        defaultValue=""
                        render={({ field, fieldState }) => (
                            <TextField
                                margin={isMobile ? 'dense' : 'normal'}
                                fullWidth
                                label={_(msg`First name`)}
                                autoComplete='firstName'
                                error={!!fieldState.error}
                                helperText={fieldState.error ? fieldState.error.message : null}
                                {...field}
                            />
                        )}
                        rules={{ required: _(msg`Name is required`) }}
                    />
                </Grid>
                <Grid item lg={6} xs={12} sx={gridItemStyle}>
                    <Controller
                        name='lastName'
                        control={control}
                        defaultValue=""
                        render={({ field, fieldState }) => (
                            <TextField
                                margin={isMobile ? 'dense' : 'normal'}
                                fullWidth
                                label={_(msg`Last name`)}
                                autoComplete='lastName'
                                error={!!fieldState.error}
                                helperText={fieldState.error ? fieldState.error.message : null}
                                {...field}
                            />
                        )}
                        rules={{ required: _(msg`Last Name is required`) }}
                    />
                </Grid>
                <Grid item lg={6} xs={12} sx={gridItemStyle}>
                    <Controller
                        name='data'
                        control={control}
                        defaultValue=""
                        render={({ field, fieldState }) => (
                            <TextField
                                margin={isMobile ? 'dense' : 'normal'}
                                fullWidth
                                label={_(msg`Data`)}
                                disabled
                                autoComplete='data'
                                error={!!fieldState.error}
                                helperText={fieldState.error ? fieldState.error.message : null}
                                {...field}
                            />
                        )}
                        rules={{ required: _(msg`Data is required`) }}
                    />
                </Grid>
                {rowToManage.publicAccident.email &&
                    <Grid item xs={12} lg={6} sx={gridItemStyle}>
                        <Controller
                            name='email'
                            control={control}
                            defaultValue=""
                            render={({ field, fieldState }) => (
                                <TextField
                                    margin={isMobile ? 'dense' : 'normal'}
                                    fullWidth
                                    label={_(msg`Email`)}
                                    required
                                    autoComplete='email'
                                    error={!!fieldState.error}
                                    helperText={fieldState.error ? fieldState.error.message : null}
                                    {...field}
                                />
                            )}
                            rules={{ required: _(msg`Email is required`) }}
                        />
                    </Grid>
                }
                {rowToManage.publicAccident.phoneNumber &&
                    <Grid item xs={12} lg={6} sx={gridItemStyle}>
                        <Controller
                            name='phoneNumber'
                            control={control}
                            defaultValue=""
                            render={({ field, fieldState }) => (
                                <TextField
                                    margin={isMobile ? 'dense' : 'normal'}
                                    fullWidth
                                    label={_(msg`Phone number`)}
                                    autoComplete='phoneNumber'
                                    error={!!fieldState.error}
                                    helperText={fieldState.error ? fieldState.error.message : null}
                                    {...field}
                                />
                            )}
                            rules={{ required: _(msg`Phone number is required`) }}
                        />
                    </Grid>
                }
                <Grid item xs={12} lg={12} sx={gridItemStyle}>
                    <Controller
                        name='region'
                        control={control}
                        defaultValue=""
                        render={({ field, fieldState }) => (
                            <TextField
                                margin={isMobile ? 'dense' : 'normal'}
                                fullWidth
                                disabled
                                label={_(msg`Region`)}
                                autoComplete='region'
                                error={!!fieldState.error}
                                helperText={fieldState.error ? fieldState.error.message : null}
                                {...field}
                            />
                        )}
                        rules={{ required: _(msg`Region is required`) }}
                    />
                </Grid>
                <Grid item xs={6} lg={6} sx={gridItemStyle}>
                    <Controller
                        name='latitude'
                        control={control}
                        defaultValue=""
                        render={({ field, fieldState }) => (
                            <TextField
                                margin={isMobile ? 'dense' : 'normal'}
                                fullWidth
                                disabled
                                label={_(msg`Latitude`)}
                                autoComplete='latitude'
                                error={!!fieldState.error}
                                helperText={fieldState.error ? fieldState.error.message : null}
                                {...field}
                            />
                        )}
                        rules={{ required: _(msg`latitude is required`) }}
                    />
                </Grid>
                <Grid item xs={6} lg={6} sx={gridItemStyle}>
                    <Controller
                        name='longitude'
                        control={control}
                        defaultValue=""
                        render={({ field, fieldState }) => (
                            <TextField
                                margin={isMobile ? 'dense' : 'normal'}
                                fullWidth
                                disabled
                                label={_(msg`Longitude`)}
                                autoComplete='longitude'
                                error={!!fieldState.error}
                                helperText={fieldState.error ? fieldState.error.message : null}
                                {...field}
                            />
                        )}
                        rules={{ required: _(msg`longitude is required`) }}
                    />
                </Grid>
            </Grid>
        )
    }

    const manageVehicleQnt = (vehicle, operation) => {
        const v = [...vehiclesRowsData]
        const idx = v.findIndex(vehicleType => vehicleType.id === vehicle.id);
        if(operation === '-'){
            v[idx].admount -= 1;
        } else {
            v[idx].admount += 1;
        }
        setVehiclesRowsData(v)
    }

    const MapAndInvolvedVehicles = () => {
        return (
            <Box sx={{display: 'flex',justifyContent: 'center', alignItems: 'center',flex:1}}>
                <Box sx={{width: isMobile ? '100%' : '30%',display:'flex',flexDirection: 'column',boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px;',mt:4}}>
                    <Box sx={{display:'flex',justifyContent:'center',padding:2,borderBottom: '1px solid lightgrey',backgroundColor: '#5cbec4',}}>
                        <Typography sx={{fontWeight:700,color:'white'}}>Select involved vehicles</Typography>
                    </Box>
                    <List sx={{display:'flex', overflowY:'auto',flexDirection:'column',flex:1}}>
                        {vehiclesRowsData.map((vehicle) => {
                            console.log('vehicle ', vehicle)
                            return (
                                <ListItem sx={{display:'flex',flexDirection:'row',justifyContent: 'space-between'}}>
                                    <Typography>{vehicle.name}</Typography>
                                    <Box sx={{display:'flex',flexDirection:'row',gap:2,alignItems:'center'}}>
                                        <IconButton disabled={vehicle.admount === 0} onClick={() => {
                                            manageVehicleQnt(vehicle, '-')
                                        }}>
                                            <Remove/>
                                        </IconButton>
                                        <Typography>{vehicle.admount}</Typography>
                                        <IconButton onClick={() => {
                                            manageVehicleQnt(vehicle, '+')
                                        }}>
                                            <AddIcon/>
                                        </IconButton>
                                    </Box>
                                </ListItem>
                            )
                        })}
                    </List>
                </Box>
            </Box>
        )
    }

    const ManageImages = () => {
        const handleAddImage = (e) => {
            const files = e.target.files
            if (files.length) {
                [...files].forEach(file => {
                    const filereader = new FileReader()
                    filereader.readAsDataURL(file)
                    // eslint-disable-next-line no-loop-func
                    filereader.onload = evt => {
                        const base64 = evt.target.result
                        console.log('base64 ---> ', base64)
                        const base64Split = base64.split(',')
                        console.log('file .. ', file)
                        const data = {
                            title: file.name,
                            description: file.name,
                            fileName: file.name,
                            fileType: file.type,
                            fileContent: base64Split[1]
                        }
                        setImages([...images, data])

                    }
                })
            }
        }
        return (
            <Box>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                    <Button component="label" color="primary">
                        <AddIcon />
                        <input
                            type="file"
                            accept="image/*"
                            capture="environment"
                            hidden
                            onChange={handleAddImage}
                        />
                    </Button>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    {images.map((image) => {
                        console.log('image ', image)
                        return (
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Typography>{image.fileName}</Typography>
                                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'center' }}>
                                    <IconButton onClick={() => {
                                        setPhotoPreview(image)
                                    }}><OpenInFullIcon /></IconButton>
                                    <IconButton onClick={() => {
                                        const imagesCopy = [...images]
                                        const idx = imagesCopy.findIndex((i) => {
                                            return i.title === image.title
                                        })
                                        if (idx !== -1) {
                                            imagesCopy.splice(idx, 1)
                                            setImages(imagesCopy)
                                        } else {
                                            return;
                                        }
                                    }}><DeleteIcon /></IconButton>
                                </Box>
                            </Box>
                        )
                    })}
                </Box>
            </Box>
        )
    }

    const saveReportAsFinal = async () => {
        setIsLoading(true)
        const source = getValues()
        const publicAccident = Object.assign(rowToManage.publicAccident, source)
        console.log('publicAccident ', publicAccident)
        const publicAccidentImages = images
        console.log('publicAccidentImages ', publicAccidentImages)
        const publicAccidentVehicleTypes = vehiclesRowsData
        console.log('publicAccidentVehicleTypes ', publicAccidentVehicleTypes)
        const resPublicAccident = await httpReq('PublicAccident/Insert', 'POST', publicAccident, false)

        if (!resPublicAccident.responseAnyError) {
            setPublicAccidentId(resPublicAccident.responseData.id)
            const reqSaveVehicleTypes = publicAccidentVehicleTypes.map(async vehicle => {
                const data = {
                    admount: vehicle.admount,
                    vehicleTypeFk: vehicle.id,
                    publicAccidentFk: resPublicAccident.responseData.id
                }
                const res = await httpReq('PublicAccidentVehicle/Insert', 'POST', data, false)
                if (!res.responseAnyError) {
                    return res.responseData
                }
            })
            await Promise.all(reqSaveVehicleTypes).then(async () => {
                if (publicAccidentImages.length > 0) {
                    const req = publicAccidentImages.map(async (image) => {
                        image.publicAccidentFk = resPublicAccident.responseData.id
                        const res = await httpReq('PublicAccidentAttachment/Insert', 'POST', image, false)
                        return res.responseData
                    })
                    await Promise.all(req).then(async () => {
                        setIsOpen(false)
                        const req = await removeFromIndexedDB(rowToManage.id, true)
                        console.log('req')
                        setIsLoading(false)
                        setIsViewAlert(true)
                        setAlertMessage('Draft saved!')
                        getRowsByIndexedDb()
                    })
                } else {
                    setIsOpen(false)
                    const req = await removeFromIndexedDB(rowToManage.id, true)
                    setIsLoading(false)
                    setIsViewAlert(true)
                    setAlertMessage('Draft saved!')
                    getRowsByIndexedDb()
                }

            })
        } else {
            setIsLoading(false)
            alert('Error')
        }
    }

    return (
        <>
            <Modal open={isOpen} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Card sx={{ height: !isMobile ? '100vh' : '100vh', width: !isMobile ? '80vw' : '100vw', padding: 4 }}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <Typography sx={{ flex: 1, fontWeight: 'bold' }} variant="h6">
                            Manage draft
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            <IconButton
                                disabled={rowsData.length === 0 || !isOnline}
                                onClick={saveReportAsFinal}
                                variant="contained"
                            >
                                <SvgCustomIcon name={'save'}/>
                            </IconButton>
                            <IconButton
                                onClick={async () => {
                                    const req = await removeFromIndexedDB(rowToManage.id, true);
                                    req.onsuccess = () => {
                                        console.log('wowo');
                                        setIsOpen(false);
                                        setIsViewAlert(true);
                                        setAlertMessage('Draft eliminated');
                                        getRowsByIndexedDb();
                                    };
                                }}
                                color="error"
                            >
                                <DeleteIcon />
                            </IconButton>

                            <IconButton onClick={() => setIsOpen(false)} color="primary">
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    </Box>
                    <CardContent>
                        <Tabs sx={{ display: 'flex', flexDirection: 'row', marginBottom: 2 }} value={selectedTab.id}>
                            {tabs.map((tab, key) => {
                                return (
                                    <Tab
                                        style={{ color: selectedTab.id === tab.id && '#005cbb' }}
                                        key={key} onClick={() => setSelectedTab(tab)} sx={{ display: 'flex', flex: 1 }}
                                        label={tab.label} value={tab.id}></Tab>
                                )
                            })}
                        </Tabs>
                        {selectedTab.id === 1 && <GeneralInfo />}
                        {selectedTab.id === 2 && <MapAndInvolvedVehicles />}
                        {selectedTab.id === 3 && <ManageImages />}

                        {photoPreview && <ModalPreviewImage isMobile={isMobile} image={photoPreview} setImage={setPhotoPreview} />}

                    </CardContent>
                </Card>
            </Modal>
            {isLoading && <Box
                sx={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    bgcolor: 'rgba(236, 235, 232, 0.9)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1301
                }}
            >
                <CircularProgress size={60} />
            </Box>}
        </>
    )

}
export default ModalManageDraft